'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPercent = exports.formatCryptoCurrency = exports.formatShares = exports.formatCurrency = exports.formatNumber = undefined;

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatNumber = exports.formatNumber = function formatNumber(number) {
  return typeof number === 'number' ? (0, _numeral2.default)(number).format('0,0[.]00') : '';
};

var formatCurrency = exports.formatCurrency = function formatCurrency(number) {
  return typeof number === 'number' ? (0, _numeral2.default)(number).format('$0,0[.]00') : '';
};

var formatShares = exports.formatShares = function formatShares(number) {
  return typeof number === 'number' ? (0, _numeral2.default)(number).format('0,0[.]00') : '';
};

var formatCryptoCurrency = exports.formatCryptoCurrency = function formatCryptoCurrency(number) {
  return typeof number === 'number' ? (0, _numeral2.default)(number).format('0.00000000') : '';
};

var formatPercent = exports.formatPercent = function formatPercent(value) {
  return typeof value === 'number' ? (value * 100).toFixed(0) : '';
};